import React from 'react'
import classNames from 'classnames/bind'
import TableAvatar from '../components/TableAvatar/TableAvatar'
import styles from './CellUser.module.scss'

const cx = classNames.bind(styles)

interface CellUserProps {
  name: string
  sub?: string
  colorIndex?: number
}

export default function CellUser({ name, sub, colorIndex }: CellUserProps) {
  const initials = name
    .split(' ')
    .map(w => w[0] ?? '')
    .slice(0, 2)
    .join('')
  const idx = colorIndex ?? ((name.charCodeAt(0) % 6) + 1)
  return (
    <div className={cx('cellUser')}>
      <TableAvatar initials={initials} colorIndex={idx} />
      <div className={cx('cellUserMeta')}>
        <div className={cx('cellUserName')}>{name}</div>
        {sub && <div className={cx('cellUserSub')}>{sub}</div>}
      </div>
    </div>
  )
}
